import { Widget } from '@/components/widget';
import { useRunningAgents } from '@/features/agents/hooks/use-running-agents';
import { ObjectsTable } from '@/components/objects-table';
import { Button } from '@/components/button';
import { useNavigate } from 'react-router-dom';

export function RunningAgentsListWidget({ id }: { id: string }) {
  const { data, isLoading } = useRunningAgents();
  const navigate = useNavigate();

  function handleResume(agentUuid: string, runUuid: string) {
    navigate(`/agents/${agentUuid}/test?runUuid=${runUuid}`);
  }

  const transformedAgents = data?.map((agent) => ({
    name: agent.agentTitle,
    uuid: agent.agentUuid,
    runUuid: agent.runUuid,
  }));

  return (
    <Widget id={id} title="Running Agents" hideable={true}>
      <ObjectsTable
        disableDrag={true}
        data={transformedAgents || []}
        isLoading={isLoading}
        onAction={(row) => (
          <Button onClick={() => handleResume(row.uuid, row.runUuid)}>
            Resume
          </Button>
        )}
      />
    </Widget>
  );
}
